import $ from 'jquery';
// import { isTouch } from '../../utils/inspection';
// import { frame } from '../../utils/drawing';
// import { directiveSettings } from '../../utils/parse';
import { onScroll } from '../utils/window';
import CountUp from 'countup.js';

const $window = $(window);

export default function countEnhancement(context=document.body) {
    const $context = $(context);
    const $count = $context.find('[sw-count]');

    if ($count.length) {

        function checkForReveal(element, settings) {
            const $this = $(element);
            const number = $this.attr('sw-count');
            const isScrolled = $window.scrollTop() + $window.outerHeight() > $this.offset().top + 100;
            if (isScrolled && !$this.hasClass('is-counted')) {
                $this.addClass('is-counted');
                let temp = new CountUp(element[0], 0, number/1, 0, 3, settings);
                temp.start();
            }
        }

        $count.each(function() {
            const $element = $(this);
            const prefix = $element.attr('sw-count-prefix');
            const separator = $element.attr('sw-count-separator');
            const settings = {
                useEasing: true, 
                useGrouping: true, 
                separator: separator ? separator : '', 
                decimal: '.', 
                suffix: prefix ? prefix : ''
            };

			checkForReveal($element, settings)

			onScroll(() => checkForReveal($element, settings));
        });

    }
}



// WEBPACK FOOTER //
// ./source/scripts/enhancements/count.js